import React from 'react'
import { Button, Stack } from '@mui/material'
import EmptyState from '@app/src/components/EmptyState/EmptyState'
import type { SvgIconComponent } from '@mui/icons-material'

interface ErrorPageProps {
  title: string
  description: string
  buttonText: string
  onButtonClick: () => void
  iconComponent: SvgIconComponent
  testId?: string
  buttonTestId?: string
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
  iconComponent,
  testId = 'error-page',
  buttonTestId = 'error-page-button',
}) => {
  return (
    <Stack data-testid={testId} justifyContent="center" alignItems="center" minHeight="100vh" paddingBottom="20vh">
      <EmptyState title={title} description={description} iconComponent={iconComponent} sx={{ maxWidth: 450 }}>
        <Button variant="outlined" size="large" onClick={onButtonClick} data-testid={buttonTestId}>
          {buttonText}
        </Button>
      </EmptyState>
    </Stack>
  )
}

export default ErrorPage
